// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_ja-0";
export var optionCard = "_ja-1";